<template>
    <ModalComponent
        :name="'borrar-base-' + base.id"
        :title="'¿Seguro que quieres borrar la base: ' + base.nombre + '?'"
        v-on:close="() => close(false)"
    >
        <div class="row">
            <div class="col-12">
                <ul class="list-group list-group-unbordered mb-3">
                    <li class="list-group-item">
                        <b>Base:</b> {{ base.nombre }}
                    </li>
                </ul>
            </div>
            <div class="col-12 text-center">
                <h1 class="font-weight-bold">¿BORRAR BASE?</h1>
            </div>
            <div class="col-12 text-center">
                <Button type="button" name="button" @click="borrarbase">SI, BORRAR</Button>
            </div>
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['base'],
        data() {
            return {
                loading: false
            }
        },
        methods: {
            close(borrado) {
                this.$emit('close', 'borrar-base-' + this.base.id, borrado);
            },
            borrarbase() {
                this.loading = true;

                const params = {
                    filters : {},
                    base_id: this.base.id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.comunicados.bases.borrar'), params).then(res => {
                    this.expand = [];
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).finally(() => this.loading = false);
            }
        },
        components: {
            ModalComponent
        }
    }
</script>
